<template>
    <div>
        <div>
            <canvas v-bind="canvasAttrs" id="nqt-pdf"></canvas>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import PDFJS from "pdfjs-dist";

    export default {
        name: "pdf-vn",
        props: {
            pdfData: {
                type: Object,
            },
            value: {
                type: Number,
                default: 0,
            },
        },
        data() {
            return {
                pdf: null,
                page: 1,
                zoom: 0,
                left: 0,
                top: 0,
                rotate: false
            };
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile,
                resize: (state) => state.learn.resize
            }),

            canvasAttrs() {

                const style = `top: ${this.top}px; left: ${this.left}px; `;

                return {
                    style
                };
            },
        },
        created() {
            // Hiển thị PDF
            this.load(this.pdfData.first);
        },
        mounted () {
            const self = this;
            document.getElementsByTagName("BODY")[0].onresize = function() {
                // Reset
                self.reload();
            };

            document.getElementById("curriculum_nqt_box_right").oncontextmenu = (e) => {
                e.preventDefault();
            }
        },
        watch: {
            value(v) {

                this.zoom = (v/5) + 1;

                this.zoom = v == 0 ? 0 : this.zoom;

                // Load pdf
                this.displayPage(this.pdf, this.page);
            },

            resize (v) {
                this.reload();
            }
        },
        methods: {
            // Hiển thị pdf lên canvas
            renderPage: function (page) {

                let offsetWidth = Number(document.getElementById("div-right").offsetWidth);
                let offsetHeight = Number(document.getElementById("div-right").offsetHeight);

                let offsetWidthAt = offsetWidth - 40;

                let width = offsetWidthAt + (this.zoom * 25);

                var vp = page.getViewport(width / page.getViewport(1.0).width);

                let scale = vp.scale;

                // Tạo canvas
                let canvas = document.getElementById("nqt-pdf");

                // Lấy viewport theo scale
                let viewport = page.getViewport(scale);

                let residualTop = Number(offsetHeight) - Number(viewport.height);
                let residualLeft = Number(offsetWidth) - Number(viewport.width);

                this.top = residualTop > 0 ? residualTop / 2 : 0;
                this.left = residualLeft > 0 ? residualLeft / 2 : 0;

                canvas.width = viewport.width;
                canvas.height = viewport.height;

                // Lấy Context của canvas
                let context = canvas.getContext("2d");

                let renderContext = {
                    canvasContext: context,
                    viewport: viewport
                };

                // Hiển thị
                let renderTask = page.render(renderContext);

                // Wait for rendering to finish
                renderTask.promise
                    .then(function () {
                        // Tải PDF thành công
                    })
                    .catch(function () {
                        // self.displayPage(self.pdf, self.page);
                    });
            },

            // Lấy dữ liệu file pdf
            displayPage: function (pdf, num) {
                const self = this;
                pdf.getPage(num).then(function getPage(page) {
                    self.renderPage(page);
                });
            },

            // Chuyển đổi từ url sang blob
            load: async function (page) {

                const blob = this.dataURItoBlob(this.pdfData.blob);
                const urls = URL.createObjectURL(blob);

                PDFJS.getDocument(urls)
                .then((pdf) => {
                    // Hiển thị PDF
                    this.displayPage(pdf, page);

                    // Lần đầu
                    this.page = page;

                    // Gán lại obj
                    this.pdf = pdf;
                })
                .catch((error) => {});
            },

            jump(page) {
                this.zoom = 0;
                
                // Hiển thị PDF theo trang
                this.displayPage(this.pdf, page);

                // Lưu lại trang hiện tại
                this.page = page;

                this.$emit("reload", true);
            },

            reload: function () {

                this.zoom = 0;

                // Hiển thị PDF
                this.displayPage(this.pdf, this.page);

                this.$emit("reload", true);
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/curriculum/pdfVn.vue